import gsap from "gsap";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(MorphSVGPlugin);
gsap.registerPlugin(ScrollTrigger);

const graph = document.querySelector("#morph-graph");
if (graph) {
  const fills = [];
  const x = graph.querySelectorAll(" #state2 ellipse");
  x.forEach((el, i) => {
    fills.push(el.getAttribute("fill"));
  });
  //console.log('fills', fills);
  MorphSVGPlugin.convertToPath("#morph-graph ellipse");
  const state1 = graph.querySelectorAll("#state1 path");
  const state2 = graph.querySelectorAll("#state2 path");
  //   MorphSVGPlugin.convertToPath("#morph-graph ellipse");

  state1.forEach((el, i) => {
    // gsap.to(el, {
    //   fill: fills[i],
    //   duration: 0,
    // })
    gsap.to(el, {
      scrollTrigger: {
        trigger: graph,
        start: "top 75%",
        end: "bottom 50%",
        scrub: 1,
      },

      morphSVG: state2[i],
    //   onReverseComplete: () => {
    //     gsap.to(el, {
    //       fill: "#082A64",
    //       duration: 0,
    //     });
    //   },
      // onComplete: () => {
      //   gsap.to(el, {
      //     fill: fills[i],
      //     duration: 0,
      //   });
      // },
    });
    // gsap.to(el, {
    //   fill: fills[i],
    //   duration: 3,
    //   ease: "power2.inOut",
    //   repeat: 1,
    //   yoyo: false,
    // });
  });
}

const ellipses = [
  { cx: 18.5, cy: 724, rx: 11.5, ry: 25, fill: "#082A64" },
  { cx: 45, cy: 724, rx: 11, ry: 25, fill: "#082A64" },
  { cx: 71.5, cy: 724, rx: 11.5, ry: 25, fill: "#082A64" },
  { cx: 98, cy: 724, rx: 11, ry: 25, fill: "#082A64" },
  { cx: 124.5, cy: 724, rx: 11.5, ry: 25, fill: "#082A64" },
  { cx: 151, cy: 724, rx: 11, ry: 25, fill: "#082A64" },
  { cx: 177.5, cy: 724, rx: 11.5, ry: 25, fill: "#082A64" },
  { cx: 204, cy: 724, rx: 11, ry: 25, fill: "#082A64" },
  { cx: 230.5, cy: 724, rx: 11.5, ry: 25, fill: "#082A64" },
  { cx: 257, cy: 724, rx: 11, ry: 25, fill: "#082A64" },
  { cx: 283.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 310, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 336.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 363, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 389.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 416, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 442.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 469, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 495.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 522, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 548.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 575, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 601.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 628, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 654.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 681, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 707.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 733.5, cy: 726, rx: 10.5, ry: 23, fill: "#082A64" },
  { cx: 759.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 786, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 812.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 839, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 865.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 892, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 918.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 945, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 971.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 998, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 1024.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 1051, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 1077.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 1104, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 1130.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 1157, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 1183.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 1210, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 1236.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 1263, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 1289.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 1316, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 1342.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 1369, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 1395.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
  { cx: 1422, cy: 726, rx: 11, ry: 23, fill: "#082A64" },
  { cx: 1448.5, cy: 726, rx: 11.5, ry: 23, fill: "#082A64" },
];

const ellipses2 = [
  { cx: 18.5, cy: 724, rx: 11.5, ry: 25, fill: "REPLACE" },
  { cx: 45, cy: 724, rx: 11, ry: 25, fill: "REPLACE" },
  { cx: 71.5, cy: 724, rx: 11.5, ry: 25, fill: "REPLACE" },
  { cx: 98, cy: 724, rx: 11, ry: 25, fill: "REPLACE" },
  { cx: 124.5, cy: 724, rx: 11.5, ry: 25, fill: "REPLACE" },
  { cx: 151, cy: 724, rx: 11, ry: 25, fill: "REPLACE" },
  { cx: 177.5, cy: 724, rx: 11.5, ry: 25, fill: "REPLACE" },
  { cx: 204, cy: 724, rx: 11, ry: 25, fill: "REPLACE" },
  { cx: 230.5, cy: 724, rx: 11.5, ry: 25, fill: "REPLACE" },
  { cx: 257, cy: 724, rx: 11, ry: 25, fill: "REPLACE" },
  { cx: 283.5, cy: 720, rx: 11.5, ry: 29, fill: "REPLACE" },
  { cx: 310, cy: 720, rx: 11, ry: 29, fill: "REPLACE" },
  { cx: 336.5, cy: 720, rx: 11.5, ry: 29, fill: "REPLACE" },
  { cx: 363, cy: 713, rx: 11, ry: 36, fill: "REPLACE" },
  { cx: 389.5, cy: 713, rx: 11.5, ry: 36, fill: "REPLACE" },
  { cx: 416, cy: 713, rx: 11, ry: 36, fill: "REPLACE" },
  { cx: 442.5, cy: 700.5, rx: 11.5, ry: 48.5, fill: "REPLACE" },
  { cx: 469, cy: 694.5, rx: 11, ry: 54.5, fill: "REPLACE" },
  { cx: 495.5, cy: 700.5, rx: 11.5, ry: 48.5, fill: "REPLACE" },
  { cx: 522, cy: 684.5, rx: 11, ry: 64.5, fill: "REPLACE" },
  { cx: 548.5, cy: 684.5, rx: 11.5, ry: 64.5, fill: "REPLACE" },
  { cx: 575, cy: 684.5, rx: 11, ry: 64.5, fill: "REPLACE" },
  { cx: 601.5, cy: 654.5, rx: 11.5, ry: 94.5, fill: "REPLACE" },
  { cx: 628, cy: 679.5, rx: 11, ry: 69.5, fill: "REPLACE" },
  { cx: 654.5, cy: 654.5, rx: 11.5, ry: 94.5, fill: "REPLACE" },
  { cx: 681, cy: 640, rx: 11, ry: 109, fill: "REPLACE" },
  { cx: 707.5, cy: 662, rx: 11.5, ry: 87, fill: "REPLACE" },
  { cx: 733.5, cy: 647.5, rx: 10.5, ry: 101.5, fill: "REPLACE" },
  { cx: 759.5, cy: 601, rx: 11.5, ry: 148, fill: "REPLACE" },
  { cx: 786, cy: 549.5, rx: 11, ry: 199.5, fill: "REPLACE" },
  { cx: 812.5, cy: 596.5, rx: 11.5, ry: 152.5, fill: "REPLACE" },
  { cx: 839, cy: 509.5, rx: 11, ry: 239.5, fill: "REPLACE" },
  { cx: 865.5, cy: 549.5, rx: 11.5, ry: 199.5, fill: "REPLACE" },
  { cx: 892, cy: 509.5, rx: 11, ry: 239.5, fill: "REPLACE" },
  { cx: 918.5, cy: 475.5, rx: 11.5, ry: 273.5, fill: "REPLACE" },
  { cx: 945, cy: 482, rx: 11, ry: 267, fill: "REPLACE" },
  { cx: 971.5, cy: 518, rx: 11.5, ry: 231, fill: "REPLACE" },
  { cx: 998, cy: 533.5, rx: 11, ry: 215.5, fill: "REPLACE" },
  { cx: 1024.5, cy: 490.5, rx: 11.5, ry: 258.5, fill: "REPLACE" },
  { cx: 1051, cy: 470, rx: 11, ry: 279, fill: "REPLACE" },
  { cx: 1077.5, cy: 432.5, rx: 11.5, ry: 316.5, fill: "REPLACE" },
  { cx: 1104, cy: 458, rx: 11, ry: 291, fill: "REPLACE" },
  { cx: 1130.5, cy: 458.5, rx: 11.5, ry: 290.5, fill: "REPLACE" },
  { cx: 1157, cy: 469, rx: 11, ry: 280, fill: "REPLACE" },
  { cx: 1183.5, cy: 487.5, rx: 11.5, ry: 261.5, fill: "REPLACE" },
  { cx: 1210, cy: 442.5, rx: 11, ry: 306.5, fill: "REPLACE" },
  { cx: 1236.5, cy: 427.5, rx: 11.5, ry: 321.5, fill: "REPLACE" },
  { cx: 1263, cy: 418.5, rx: 11, ry: 330.5, fill: "REPLACE" },
  { cx: 1289.5, cy: 452.5, rx: 11.5, ry: 296.5, fill: "REPLACE" },
  { cx: 1316, cy: 438.5, rx: 11, ry: 310.5, fill: "REPLACE" },
  { cx: 1342.5, cy: 406.5, rx: 11.5, ry: 342.5, fill: "REPLACE" },
  { cx: 1369, cy: 415, rx: 11, ry: 334, fill: "REPLACE" },
  { cx: 1395.5, cy: 406.5, rx: 11.5, ry: 342.5, fill: "REPLACE" },
  { cx: 1422, cy: 406.5, rx: 11, ry: 342.5, fill: "REPLACE" },
  { cx: 1448.5, cy: 406.5, rx: 11.5, ry: 342.5, fill: "REPLACE" },
];
